// Shared state management for chat to prevent iframe reloads during chat requests
const CHAT_IN_PROGRESS_KEY = 'chat_request_in_progress';

export const setChatInProgress = (inProgress) => {
  if (inProgress) {
    localStorage.setItem(CHAT_IN_PROGRESS_KEY, 'true');
  } else {
    localStorage.removeItem(CHAT_IN_PROGRESS_KEY);
  }
};

export const isChatInProgress = () => {
  return localStorage.getItem(CHAT_IN_PROGRESS_KEY) === 'true';
};

// Suppress all iframe reloads while user is in inline edit mode.
let _editModeActive = false;

export const setEditModeActive = (active) => { _editModeActive = !!active; };
export const isEditModeActive = () => _editModeActive;

// Keep old reinject exports so nothing else breaks
export const setReinjectInProgress = () => {};
export const isReinjectInProgress = () => false;
